import { useState } from "react";
import { PencilSquareIcon } from "@heroicons/react/20/solid";
import { cn } from "@/utils/classes";

/* Prop Types */
interface EditElementProps {
  defaultValue: string;
  elementId: string;
  children: React.ReactNode;
  className?: string;
  handleElementEdit: (elementId: string, newText: string) => void;
}

/*
 * EditElement component
 * It provides the functionality to edit the text of an element and save it
 *
 * Note: To make the pencil hover work you have to add the "group" class to the parent element
 */
export const EditElement = ({ defaultValue, elementId, children, className, handleElementEdit }: EditElementProps) => {
  /* State */
  const [editElementId, setEditElementId] = useState("");

  /* Render */
  return (
    <>
      {editElementId === elementId ? (
        <>
          <input
            type="text"
            defaultValue={defaultValue}
            autoFocus
            className={cn(`border rounded-sm px-2 py-1 w-full max-w-80 text-sm`, className)}
            onBlur={(e) => {
              setEditElementId("");
              handleElementEdit(elementId, e.currentTarget.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleElementEdit(elementId, e.currentTarget.value);
                setEditElementId("");
              }
              if (e.key === "Escape") {
                setEditElementId("");
              }
            }}
          />
        </>
      ) : (
        <>
          {children}
          <PencilSquareIcon
            className="size-4 ml-auto opacity-0 group-hover:opacity-100 cursor-pointer shrink-0"
            onClick={() => {
              setEditElementId(elementId);
            }}
          />
        </>
      )}
    </>
  );
};
